import type {ReactNode} from 'react'
import {DialogContent} from '@/components/ui/dialog'
import {cn} from '@/lib/utils'

interface LargeDialogProps {
    children: ReactNode
    className?: string
}

export function LargeDialog({children, className}: LargeDialogProps) {
    return (
        <DialogContent className={cn('max-w-2xl max-h-[90vh] overflow-y-auto', className)}>
            {children}
        </DialogContent>
    )
}
